import { Api } from "../../common/service/Api";
import { OrganizationPublicId } from "../../common/service/server/Types";
import { Routes } from "../root/routes";

// Org/phase changes require a fresh routing context. Do not invalidate the old
// page's queries before leaving: it could render the new org at the old URL.
export async function switchActiveOrganization(organizationId: OrganizationPublicId) {
  await Api.user.updateSelfActiveOrganization(organizationId);
  window.location.replace(Routes.root);
}

export async function acceptInvitationAndSwitchOrganization(organizationId: OrganizationPublicId) {
  // Acceptance consumes the invitation. Check server membership on every attempt
  // so a failed switch (or lost acceptance response) can be retried safely.
  const user = await Api.user.getSelf();
  if (!user) {
    throw new Error("Sign in before accepting this invitation.");
  }
  const alreadyMember = user.organizations.some(
    (organization) =>
      organization.organization === organizationId && organization.status === "ACTIVE",
  );
  if (!alreadyMember) {
    await Api.user.acceptInvitation(organizationId);
  }
  await switchActiveOrganization(organizationId);
}

export async function completeBusinessSurveyAndNavigate(
  organizationId: OrganizationPublicId,
  onComplete: () => void,
) {
  await Api.organization.setGetCompliantDone(organizationId, true);
  onComplete();
  window.location.replace(Routes.organization.settings.businessSurvey);
}
